import styled from 'styled-components'

type Props = {
	square?: boolean
}

export const Base = styled.div<Props>`
	position: absolute;
	width: 100%;
	height: 100%;

	border-radius: ${({ square }) => (square ? '0%' : '50%')};
`
